<template>
  <div class="Metrics">
    <block-title title="Metrics"></block-title>
    <ul class="Metrics-list">
      <li v-for="data in metrics" :key="data.id" class="Item">
        <i class="material-icons Icons">{{ data.icon }}</i>
        <h3 class="Title">{{ data.label }}</h3>
        <div class="Content" v-html="data.value"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import BlockTitle from './BlockTitle'

export default {
  name: 'Metrics',
  components: {BlockTitle},
  props: {
    stats: {
      type: Object,
      default: () => ({}) // factory return empty object
    }
  },
  computed: {
    metrics() {
      return [
        {
          id: 0,
          label: 'Total actors',
          value: this.stats.descendants || '0',
          icon: 'brightness_1'
        },
        {
          id: 1,
          label: 'Children actors',
          value: this.stats.children || '0',
          icon: 'adjust'
        },
        {
          id: 2,
          label: 'Total topics',
          value: this.stats.totalTopics || '0',
          icon: 'forum'
        },
        {
          id: 3,
          label: 'Own topics',
          value: this.stats.ownTopics || '0',
          icon: 'chat_bubble'
        }
      ]
    }
  },
  methods: {}
}
</script>

<style>
.Metrics {
  &-list {
    margin: 0;
    padding: 0;
    .Item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .Title,
      .Content {
        font-size: 15px;
      }
      .Icons {
        color: #969696;
        font-size: 18px;
        margin-right: 10px;
      }
      .Title {
        min-width: 160px;
        color: #969696;
      }
      .Content {
        color: #171717;
      }
    }
  }
}
</style>
